import React, { useState } from 'react'
import { MDBDropdown, MDBDropdownMenu, MDBDropdownToggle, MDBInput, MDBCheckbox } from 'mdb-react-ui-kit'

export const EmailDistributionFilterDropDown = ({ disabled, label, name, onChange, options, value, onFilter }) => {
  const [filter, setFilter] = useState(null)
  const onSearch = e => {
    setFilter(e.target.value)
  }
  const onValueChange = e => {
    let selected = [...value]
    e = isNaN(parseInt(e)) ? `${e}`.trim() : parseInt(e)
    if (selected.indexOf(e) > -1) selected.splice(selected.indexOf(e), 1)
    else selected.push(e)

    onChange(selected)
  }

  const onSelectAll = () => {
    if (isAllSelected()) {
      // Unselect all
      onChange([])
    } else {
      // Select all
      const allValues = filteredOptions.map(option => option.value)
      onChange(allValues)
    }
  }

  const filteredOptions =
    options && Array.isArray(options)
      ? options.filter(
          onFilter && typeof onFilter === 'function'
            ? c => onFilter(c, filter)
            : data => {
                return filter ? `${data.label}`.toLowerCase().indexOf(filter) > -1 : true
              }
        )
      : []

  const isAllSelected = () => {
    if (!filteredOptions.length) return false
    return filteredOptions.every(option => value && value.includes(option.value))
  }
  return (
    <MDBDropdown>
      <MDBDropdownToggle className='dropdown-toggle-caret' type='button' disabled={disabled} color='indigo'>
        {label}
      </MDBDropdownToggle>
      <MDBDropdownMenu basic onClick={e => e.stopPropagation()}>
        <MDBInput label={`Search ${label}`} name={name} value={filter} onChange={onSearch} />
        {label === 'Usertypes' && filteredOptions.length > 0 ? (
          <div
            className='dropdown-checkbox-item select-all'
            onClick={e => e.stopPropagation()}
            onMouseDown={e => e.stopPropagation()}
          >
            <MDBCheckbox
              checked={isAllSelected()}
              key='select-all-usertypes'
              label='Select All'
              id='select-all-usertypes-checkbox'
              name='select-all-usertypes-checkbox'
              className={isAllSelected() ? 'is-checked' : ''}
              onChange={e => {
                e.stopPropagation()
                onSelectAll()
              }}
            />
          </div>
        ) : (
          <span style={{ display: 'none' }} aria-hidden />
        )}
        {filteredOptions.length > 0 ? (
          <React.Fragment>
            {filteredOptions.map((option, i) => (
              <div
                key={'st-input-' + i}
                className='dropdown-checkbox-item'
                onClick={e => e.stopPropagation()}
                onMouseDown={e => e.stopPropagation()}
              >
                <MDBCheckbox
                  checked={value && Array.isArray(value) ? value.includes(option.value) : false}
                  label={option.label}
                  id={'state-ckbox-' + option.value}
                  name={'state-ckbox-' + option.value}
                  className={option.checked ? 'is-checked' : ''}
                  onChange={e => {
                    e.stopPropagation()
                    onValueChange(option.value)
                  }}
                />
              </div>
            ))}
          </React.Fragment>
        ) : (
          <span style={{ display: 'none' }} aria-hidden />
        )}
      </MDBDropdownMenu>
      <ul className='results'>
        {value && Array.isArray(value) && value.length ? (
          value.map((val, i) => {
            return (
              <li onClick={() => onValueChange(val)} key={'st-tag-' + i}>
                {options.filter(option => `${option.value}` === `${val}`)[0].label}
              </li>
            )
          })
        ) : (
          <li className='all'>All {label}</li>
        )}
      </ul>
    </MDBDropdown>
  )
}
